import React, { useState, useEffect } from "react";
import "./App.css";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";

// Component Imports
// ✅ Updated path to System directory
import BlogManager from "./Component/System/BlogManager"; 
import PostYoutubeLink from "./Component/PostFunction/PostYoutubeLink";

import CustomerTestimonials from "./Component/PostFunction/CustomerTestimonials";
import UpdateCustomerTestimonials from "./Component/PostFunction/UpdateCustomerTestimonials";
import Dashboard from "./Component/Dashboard/Dashboard";

import BulkRoleAssignment from "./Component/System/BulkRoleAssignment";
import AdminSignup from "./Component/System/AdminSignup";
import AdminLogin from "./Component/System/AdminLogin";
import CreateAccount from "./Component/System/CreateAccount";
import TeamMembers from "./Component/System/TeamMembers";
import MainNavigation from "./Component/Navigation/MainNavigation";
import ManagePortfolios from "./Component/System/ManagePortfolios";
import Inquiries from "./Component/System/InquiriesList";
import RecruitmentDashboard from "./Component/System/RecruitmentDashboard";

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [hasCheckedAuth, setHasCheckedAuth] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("admin-auth");
    const loggedIn = !!token;
    setIsAuthenticated(loggedIn);
    setHasCheckedAuth(true);

    if (!loggedIn && location.pathname !== "/AdminLogin") {
      navigate("/AdminLogin", { state: { from: location.pathname } });
    }
  }, [location.pathname, navigate]);

  if (!hasCheckedAuth) {
    return null; // Prevents layout flashing during initial authentication check
  }

  return (
    <div className="min-h-screen bg-[#F8FAFC] font-sans text-slate-900">
      <Toaster position="top-right" />

      {!isAuthenticated ? (
        <Routes>
          <Route path="/AdminLogin" element={<AdminLogin setIsAuthenticated={setIsAuthenticated} />} />
          <Route path="*" element={<AdminLogin setIsAuthenticated={setIsAuthenticated} />} />
        </Routes>
      ) : (
        <div className="relative">
          {/* ✅ NAVIGATION */}
          <MainNavigation 
            isSidebarOpen={isSidebarOpen} 
            setIsSidebarOpen={setIsSidebarOpen} 
          />

          {/* ✅ MAIN CONTENT WRAPPER */}
          <main
            className={`transition-all duration-300 ease-in-out min-h-screen pt-16
              ${isSidebarOpen ? "lg:pl-64" : "pl-0"}`}
          >
            <div className="p-4 md:p-6 lg:p-8 max-w-[1600px] mx-auto">
              
              {/* Statutory Page Header */}
              <div className="mb-6 no-print">
                 <div className="flex items-center gap-2">
                    <div className="h-1 w-8 bg-[#06038D]"></div>
                    <p className="text-[10px] font-black uppercase tracking-[0.3em] text-slate-400">
                      System Node / {location.pathname.replace("/", "") || "Main_Dashboard"}
                    </p>
                 </div>
              </div>

              <Routes>
                {/* Core Routes */}
                <Route path="/" element={<Dashboard />} />
                <Route path="/admin/dashboard" element={<Dashboard />} />
                
                {/* 📝 BLOG MANAGEMENT ROUTES */}
                <Route path="/blogs" element={<BlogManager />} />
                <Route path="/BlogPost" element={<BlogManager />} />
                <Route path="/create-blog" element={<BlogManager />} />
                <Route path="/edit-blog/:id" element={<BlogManager />} />

                {/* Video / YouTube Content */}
                <Route path="/youtube-post" element={<PostYoutubeLink />} />
               
                {/* Testimonials */}
                <Route path="/CustomerTestimonials" element={<CustomerTestimonials />} />
                <Route path="/UpdateCustomerTestimonials" element={<UpdateCustomerTestimonials />} />
                
                {/* System & Operations */}
                <Route path="/Role" element={<BulkRoleAssignment />} />
                <Route path="/AdminSignup" element={<AdminSignup />} />
                <Route path="/CreateAccount" element={<CreateAccount />} />
                <Route path="/team-members" element={<TeamMembers />} />
                <Route path="/portfolios" element={<ManagePortfolios />} />
                <Route path="/inquiries" element={<Inquiries />} />
                <Route path="/recruitment" element={<RecruitmentDashboard />} />
                
              </Routes>
            </div>
          </main>
        </div>
      )}
    </div>
  );
}

export default App;